import { WZStatus } from '../types/wz';



const EDITABLE_WZ_STATUSES = Object.values(WZStatus);

const EDITABLE_STATUS_TRANSITIONS: Record<WZStatus, WZStatus[]> = {
  [WZStatus.DRAFT]: [WZStatus.DRAFT, WZStatus.RELEASED, WZStatus.CANCELLED],
  [WZStatus.CONFIRMED]: [WZStatus.CONFIRMED, WZStatus.RELEASED, WZStatus.CANCELLED],
  [WZStatus.RELEASED]: [WZStatus.RELEASED],
  [WZStatus.RECEIVED]: [WZStatus.RECEIVED],
  [WZStatus.CANCELLED]: [WZStatus.CANCELLED],
};

export function isWZEditable(status?: WZStatus) {
  return !status || EDITABLE_WZ_STATUSES.includes(status);
}

export function canShowWZEditAction(status: WZStatus) {
  return EDITABLE_WZ_STATUSES.includes(status);
}

/**
 * Minimum length of a correction reason on a released WZ. Mirrors the backend
 * rule in wzCorrectionService.WZ_CORRECTION_REASON_MIN_LENGTH (owner decision
 * 2026-09-18); the backend remains the authority.
 */
export const WZ_CORRECTION_REASON_MIN_LENGTH = 10;

export function getEditableWZStatusOptions(status?: WZStatus) {
  return EDITABLE_STATUS_TRANSITIONS[status || WZStatus.DRAFT];
}
